// $(document).ready(function () {
//     // 点击打开按钮显示弹窗和遮罩层
//     $(".wb_proleft_head").click(function () {
//         $(".overlay_model, .product_description_model").fadeIn();
//         $(".modal").css("bottom", "0"); // 底部上升到页面
//     });

//     // 点击遮罩层关闭弹窗
//     $(".overlay_model").click(function () {
//         $(".product_description_model").css("bottom", "-90vh"); // 返回到底部之外
//         $(".overlay_model").fadeOut();
//         setTimeout(function () {
//             $(".product_description_model").fadeOut();
//         }, 200); // 延迟关闭，以等待动画效果完成
//     });
// });

class ModalDialogMb extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]')?.addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this?.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this?.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this?.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("m-modal-dialog", ModalDialogMb);

class ModalOpenerMb extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");
    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal?.show(button);
    });
  }
}
customElements.define("m-modal-opener", ModalOpenerMb);

window.theme = window.theme || {};

theme.wishList = function () {
  var wishName = "wishList";
  var localWishList = "localWishList";
  const loginFlag = theme.isLogin();
  init(), wishlist(), updateWishlist();
  // 用户登录时判断本地localStorage 是否有数据，有数据则上报到服务器
  function init() {
    const wishlist = getStorage(localWishList);
    if (wishlist && wishlist?.length > 0 && loginFlag) {
      addToWish(wishlist);
      clearStorage(localWishList);
    }
  }
  function wishlist() {
    $(document).on("click", ".addto-wishlist", function (e) {
      var id = this.dataset.id;
      addToWish([String(id)]);
      // e.preventDefault();
    });
    $(document).on("click", ".cancel-wishlist", async function (e) {
      var id = this.dataset.id;
      if (loginFlag) {
        const params = {
          sid: [String(id)],
          favorite: false,
        };
        const response = await fetchRequest(
          "api/v1/my/favorite/update",
          "POST",
          params
        );

        if (!response.error) {
          hideWish(id);
          removeStorage(id, wishName);
        }
      } else {
        hideWish(id);
        removeStorage(id, wishName);
        removeStorage(id, localWishList);
      }
    });
  }

  async function addToWish(sid) {
    if (loginFlag) {
      const params = {
        sid,
        favorite: true,
      };
      const response = await fetchRequest(
        "api/v1/my/favorite/update",
        "POST",
        params
      );
      if (!response.error) {
        $(this).find(".at").addClass("at-circle-notch-r at-spin");
        sid.forEach((id) => {
          setStorage(id, wishName);
          showWish(id);
        });
      }
    } else {
      $(this).find(".at").addClass("at-circle-notch-r at-spin");
      sid.forEach((id) => {
        setStorage(id, localWishList);
        setStorage(id, wishName);
        showWish(id);
      });
    }
  }
  async function updateWishlist() {
    var AddWishEle = document.querySelector(".addto-wishlist");
    if (!AddWishEle) return;

    if (loginFlag) {
      const params = {
        page: 1,
        size: 100,
      };
      const response = await fetchRequest(
        "api/v1/my/favorite/list",
        "POST",
        params
      );
      if (!response.error) {
        const list = response.data?.products;
        if (list && list.length > 0) {
          var wishData = [];
          for (let i in list) {
            wishData.push(list[i].id);
          }
          localStorage.setItem(
            wishName,
            JSON.stringify([...new Set(wishData)])
          );
        }
      }
      showWishList();
    } else {
      showWishList();
    }
  }

  function showWish(id) {
    $('.wishlist[data-id="' + id + '"] .no-wish').hide();
    $('.wishlist[data-id="' + id + '"]')
      .removeClass("addto-wishlist")
      .addClass("cancel-wishlist")
      .find("span")
      .text(theme.wlAvailable);
    $('.wishlist[data-id="' + id + '"] .at')
      .removeClass("at-circle-notch-r at-spin")
      .show();
  }

  function showWishList() {
    var wishData = JSON.parse(localStorage.getItem(wishName));
    if (wishData && wishData.length > 0) {
      for (let i in wishData) {
        $('.wishlist[data-id="' + wishData[i] + '"]')
          .removeClass("addto-wishlist")
          .addClass("cancel-wishlist")
          .find("span")
          .text(theme.wlAvailable);
        $('.wishlist[data-id="' + wishData[i] + '"] .no-wish').hide();
        $('.wishlist[data-id="' + wishData[i] + '"] .at').show();
        $(".favCount").text(i).removeClass("hide");
      }
    }
  }

  function hideWish(id) {
    $('.wishlist[data-id="' + id + '"] .no-wish').show();
    $('.wishlist[data-id="' + id + '"]')
      .addClass("addto-wishlist")
      .removeClass("cancel-wishlist")
      .find("span")
      .text(theme.wlAvailable);
    $('.wishlist[data-id="' + id + '"] .at').hide();
  }

  function getStorage(name) {
    var wishString = localStorage.getItem(name);
    var wishData = theme.inspectJson(wishString) || [];
    return wishData;
  }

  function setStorage(id, name) {
    var wishString = localStorage.getItem(name);
    var wishData = theme.inspectJson(wishString) || [];
    wishData.push(id);
    localStorage.setItem(name, JSON.stringify([...new Set(wishData)]));
  }

  function removeStorage(id, name) {
    var wishData = JSON.parse(localStorage.getItem(name));
    let newList = wishData.filter((item) => item != id);
    localStorage.setItem(name, JSON.stringify([...new Set(newList)]));
  }
  function clearStorage(name) {
    localStorage.removeItem(name);
  }
};

theme.filtersss = function () {
  $(".filter-btn").click(function (event) {
    event.stopPropagation();
    var target = $(this).data("target");

    $(".filter-btn").each(function () {
      $(this).removeClass("wuyula");
    });
    $(this).addClass("wuyula");

    // 判断目标元素是否已经显示
    if ($(target).hasClass("active")) {
      // 如果显示，则隐藏它
      $(target).removeClass("active").css("display", "none");
      $(this).removeClass("wuyula");

      $(".vov").hide();
      document.body.classList.remove("overflow-hidden-mobile");
    } else {
      // 如果没有显示，则隐藏其他元素并显示目标元素
      $(".category-contents").removeClass("active").css("display", "none");
      $(target).css("display", "block");

      setTimeout(function () {
        $(".vov").show();
        document.body.classList.add("overflow-hidden-mobile");
        $(target).addClass("active");
      }, 10);
    }
  });

  $(".category-contents").click(function (event) {
    event.stopPropagation();
  });

  $(document).click(function () {
    $(".category-contents").removeClass("active").css("display", "none");
    document.body.classList.remove("overflow-hidden-mobile");
    $(".vov").hide();

    $(".filter-btn").each(function () {
      $(this).removeClass("wuyula");
    });
  });
};

theme.setSold = function () {
  const url = "api/v1/product/sold";
  const pathname = window.location.pathname;
  const elements = pathname.includes("products")
    ? document.querySelector(".product-sold")
    : document.querySelectorAll('input[name="product-id"]');
  const idList = [];
  const soldElements = pathname.includes("products")
    ? document.querySelector(".product-sold")
    : document.querySelectorAll("product-sold.product-sold");
  if (pathname.includes("products")) {
    const value = elements?.dataset?.id;
    idList.push(parseInt(value));
  } else {
    elements.forEach((item) => {
      idList.push(parseInt(item.value));
    });
  }

  if (idList.length == 0) return;
  const params = {
    id: idList,
  };
  fetchRequest(url, "POST", params).then((response) => {
    if (!response.error) {
      const dataList = response.data;
      if (Object.keys(dataList).length > 0) {
        for (let key in dataList) {
          if (pathname.includes("products")) {
            const id = elements.dataset.id;
            if (key == id) {
              const sold = dataList[key];
              if (sold > 0) {
                elements.innerHTML = `Sold Recently: <span class="active-color">${displayNumber(
                  sold
                )}</span>`;
              }
            }
          } else {
            soldElements.forEach((ele) => {
              const id = ele.dataset.id;
              if (key == id) {
                const sold = dataList[key];
                if (sold > 0) {
                  ele.innerHTML = `${displayNumber(sold)} Sold`;
                }
              }
            });
          }
        }
      }
    }
  });
};

theme.getIsFreeShipping = function () {
  const freeShipHandle = [
    "straw-bag",
    "jewelry-packaging",
    "jewelry-boxes",
    "sunglasses",
    "watches",
    "hair-claws",
    "chunky-hair-accessories",
    "dress",
    "swimwear",
    "makeup-bags",
    "jewelry-packaging-display",
  ];

  const pageUrl = window.location.href;
  if (pageUrl.indexOf("/cart") != -1) return;
  const url = "web.ProductService/QueryProductFreeShipping";
  const productIdEle = document.querySelectorAll(`.free-shipping[data-id]`);
  const productIds = [];

  // 获取上一个页面的URL
  const referrer = document.referrer;
  const isFromPromotion =
    referrer && referrer.indexOf("pages/promotion") !== -1;
  for (let item of productIdEle) {
    const handle = item.dataset?.collection;
    if (isFromPromotion && freeShipHandle.includes(handle)) {
      item?.classList?.remove("hidden");
    }
    const id = item.dataset.id;
    productIds.push(id);
  }
  if (productIds.length == 0) return;
  const params = {
    id: productIds,
  };
  fetchConnect(url, "POST", params).then((response) => {
    if (!response.error) {
      const data = response?.data?.items;
      for (let item of productIdEle) {
        const id = item.dataset.id;
        if (data[id]) {
          item?.classList?.remove("hidden");
        }
      }
    
    }
    const swiperContainers = document.querySelectorAll(".swiper-tag");
    swiperContainers.forEach((container) => {
      new Swiper(container, {
        direction: "vertical",
        loop: true,
        autoplay: true,
        delay: 1500,
      });
    });
  });
};

// 判断json是否合法
theme.inspectJson = function (jsonString) {
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    return false;
  }
};

// 币种之间相互转换
theme.convertCurrency = function (price = 0, type, notRise) {
  // console.log(price, type, notRise);
  let fromCurrency = "";
  let toCurrency = "";
  const jsonString = theme.getCookies("userSelected");
  const userSelected = theme.inspectJson(jsonString);
  const setCurrency = userSelected?.currency_code ?? "USD"; // 用户设置币种
  const usdCurrency = "USD"; // USD
  const localCurrency = theme.getCookies("cart_currency") ?? "USD"; // shopify 本地币种
  // shopify本地币种转美元
  if (type == "localToUsd") {
    fromCurrency = localCurrency;
    toCurrency = usdCurrency;
  }
  // shopify本地币种转用户设置币种
  if (type == "localToSet") {
    fromCurrency = localCurrency;
    toCurrency = setCurrency;
  }
  // 美元转用户设置币种
  if (type == "usdToSet") {
    fromCurrency = usdCurrency;
    toCurrency = setCurrency;
  }
  // 设置币种转美元
  if (type == "setToUsd") {
    fromCurrency = setCurrency;
    toCurrency = usdCurrency;
  }
  if (fromCurrency != "" && toCurrency != "") {
    if (type == "usdToSet" && toCurrency != fromCurrency) {
      if (notRise) {
        return parseFloat(
          Currency.convert(price, fromCurrency, toCurrency).toFixed(2)
        );
      }
      // 美元转墨西哥比索， 价格上浮8%
      if (toCurrency == "MXN") {
        // 计算公式： price * 100 * 1.08 向上取整后 / 汇率 后向上取整后 * 1.02 取整
        const rate = 1.02;
        const rise = 1.08;
        const newPrice = theme.multiply(100, price);
        const price1 = Number(theme.multiply(newPrice, rise)?.toFixed());
        const price2 = Number(
          Currency.convert(price1, fromCurrency, toCurrency)?.toFixed()
        );
        const lastPrice = parseInt(theme.multiply(price2, rate));
        return theme.roundToTwo(lastPrice / 100);
      } else {
        const rate = 0.02;
        const rise = 1.07;
        let newPrice = 0;
        if (notRise) {
          newPrice = Number(theme.multiply(100, price));
        } else {
          newPrice = Number(
            theme.multiply(theme.multiply(100, price), rise)?.toFixed()
          );
        }

        const convertPrice = Currency.convert(
          newPrice,
          fromCurrency,
          toCurrency
        );
        const fee = theme.multiply(rate, convertPrice);
        const lastPrice = theme.add(parseInt(fee), parseInt(convertPrice));
        return theme.roundToTwo(lastPrice / 100);
      }
    }

    if (type == "usdToSet" && toCurrency == fromCurrency) {
      const rise = 1.07;
      if (notRise) {
        return price;
      }
      const newPrice = Number(
        theme.multiply(theme.multiply(100, price), rise)?.toFixed()
      );
      return theme.roundToTwo(newPrice / 100);
    }
    return parseFloat(
      Currency.convert(price, fromCurrency, toCurrency).toFixed(2)
    );
  }
  return parseFloat(price?.toFixed(2));
};

theme.formatPrice = function (price, showSymbol = true) {
  const jsonString = theme.getCookies("userSelected");
  const userSelected = theme.inspectJson(jsonString);
  // const currencyCode = userSelected?.currency_code ?? "USD";
  const currencySymbol = decodeURIComponent(
    userSelected?.currency_symbol ?? "US$"
  );

  if (showSymbol) {
    return `${currencySymbol}${price}`;
  }
  return `${price}`;
};

// 保留两位小数+四舍五入
theme.roundToTwo = function (num) {
  return Number(Math.round(num + "e2") + "e-2");
};

// 两数相乘
theme.multiply = function (num1, num2) {
  // 参数验证
  if (typeof num1 !== "number" || typeof num2 !== "number") {
    return;
  }

  // 处理特殊情况
  if (isNaN(num1) || isNaN(num2)) return NaN;
  if (!isFinite(num1) || !isFinite(num2)) return Infinity;

  try {
    // 将数字转换为字符串
    const str1 = num1.toString();
    const str2 = num2.toString();

    // 获取小数位数
    const decimal1 = (str1.split(".")[1] || "").length;
    const decimal2 = (str2.split(".")[1] || "").length;

    // 将字符串转为整数
    const int1 = Number(str1.replace(".", ""));
    const int2 = Number(str2.replace(".", ""));

    // 计算结果
    const result = (int1 * int2) / Math.pow(10, decimal1 + decimal2);

    // 处理精度，避免科学计数法
    return Number(result.toFixed(decimal1 + decimal2));
  } catch (error) {
    console.error("计算出错：", error);
    return NaN;
  }
};
// 两数相加
theme.add = function (num1, num2) {
  // 参数验证
  if (typeof num1 !== "number" || typeof num2 !== "number") {
    return;
  }

  // 处理特殊情况
  if (isNaN(num1) || isNaN(num2)) return NaN;
  if (!isFinite(num1) || !isFinite(num2)) return Infinity;

  try {
    // 将数字转换为字符串
    const str1 = num1.toString();
    const str2 = num2.toString();

    // 获取小数位数
    const decimal1 = (str1.split(".")[1] || "").length;
    const decimal2 = (str2.split(".")[1] || "").length;

    // 获取最大小数位数
    const maxDecimal = Math.max(decimal1, decimal2);

    // 转换为整数计算
    const multiple = Math.pow(10, maxDecimal);
    const int1 = Math.round(num1 * multiple);
    const int2 = Math.round(num2 * multiple);

    // 计算结果
    const result = (int1 + int2) / multiple;

    // 处理精度，避免科学计数法
    return Number(result.toFixed(maxDecimal));
  } catch (error) {
    console.error("计算出错：", error);
    return NaN;
  }
};
// 两数相除
theme.divide = function (dividend, divisor, decimals = 2) {
  // 参数验证
  if (typeof dividend !== "number" || typeof divisor !== "number") {
    return Number.NaN;
  }

  // 处理特殊情况
  if (Number.isNaN(dividend) || Number.isNaN(divisor)) return Number.NaN;
  if (!Number.isFinite(dividend) || !Number.isFinite(divisor)) return Infinity;
  if (divisor === 0) return Infinity; // 除数为0返回Infinity

  try {
    // 执行除法运算
    const result = dividend / divisor;

    // 如果结果是整数，直接返回
    if (Number.isInteger(result)) return result;

    // 根据指定的小数位数进行四舍五入
    return Number(result.toFixed(decimals));
  } catch (error) {
    return Number.NaN;
  }
};
// 两数相减
theme.subtract = function (num1, num2) {
  // 参数验证
  if (typeof num1 !== "number" || typeof num2 !== "number") {
    return;
  }

  // 处理特殊情况
  if (isNaN(num1) || isNaN(num2)) return NaN;
  if (!isFinite(num1) || !isFinite(num2)) return Infinity;

  try {
    // 将数字转换为字符串
    const str1 = num1.toString();
    const str2 = num2.toString();

    // 获取小数位数
    const decimal1 = (str1.split(".")[1] || "").length;
    const decimal2 = (str2.split(".")[1] || "").length;

    // 获取最大小数位数
    const maxDecimal = Math.max(decimal1, decimal2);

    // 转换为整数计算
    const multiple = Math.pow(10, maxDecimal);
    const int1 = Math.round(num1 * multiple);
    const int2 = Math.round(num2 * multiple);

    // 计算结果
    const result = (int1 - int2) / multiple;

    // 处理精度，避免科学计数法
    return Number(result.toFixed(maxDecimal));
  } catch (error) {
    console.error("计算出错：", error);
    return NaN;
  }
};
// 判断是否移动端
theme.checkIsMobile = function () {
  var userAgent = navigator.userAgent;
  if (userAgent.match(/Mobile|Android/i)) {
    return true;
  } else {
    var mq = window.matchMedia("(max-width: 1280px)");
    if (mq.matches) {
      return true;
    } else {
      return false;
    }
  }
};
function displayNumber(number) {
  if (number > 1000) {
    return (number / 1000).toFixed(1) + "K+";
  }
  return number;
}

function setCookie(name, value, times) {
  var expires = "";
  if (times) {
    var date = new Date();
    date.setTime(date.getTime() + times * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie =
    name + "=" + (value || "") + expires + "; path=/; domain=.gooddiy.com;";
}

// 获取cookie
theme.getCookies = function (name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

// 删除cookie
theme.deleteCookie = function (name) {
  document.cookie = `${name}=; expires=${new Date(0)}; path=/;`;
};

function padZero(num) {
  return num < 10 ? "0" + num : num;
}
// 倒计时计算
theme.countdown = function (end, showDays = true) {
  const now = new Date().getTime();
  const endDate = new Date(end).getTime();
  const distance = endDate - now;

  if (distance < 0) {
    return showDays
      ? {
          days: `00`,
          hours: `00`,
          minutes: `00`,
          seconds: `00`,
        }
      : {
          hours: `00`,
          minutes: `00`,
          seconds: `00`,
        };
  }

  if (showDays) {
    const days = padZero(Math.floor(distance / (1000 * 60 * 60 * 24)));
    const hours = padZero(
      Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    );
    const minutes = padZero(
      Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
    );
    const seconds = padZero(Math.floor((distance % (1000 * 60)) / 1000));

    return {
      days,
      hours,
      minutes,
      seconds,
    };
  } else {
    const totalHours = padZero(Math.floor(distance / (1000 * 60 * 60)));
    const minutes = padZero(
      Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
    );
    const seconds = padZero(Math.floor((distance % (1000 * 60)) / 1000));

    return {
      hours: totalHours,
      minutes,
      seconds,
    };
  }
};

theme.matchMenu = function () {
  const path = window.location.pathname;
  const asideLinks = document.querySelectorAll(".aside-menu .link-items");

  asideLinks?.forEach((link) => {
    if (path.indexOf(link?.dataset?.title) != -1) {
      link?.classList.add("active");
    } else {
      link?.classList.remove("active");
    }
    link?.addEventListener("click", (e) => {
      asideLinks.forEach((otherLink) => {
        otherLink?.classList.remove("active");
      });
      link?.classList.add("active");
    });
  });
};
function calculatePrice(list) {
  if (!list || list.length === 0) return 0;
  let total = 0;
  for (let item of list) {
    const variantPriceCount = theme.multiply(
      Number(item.final_price),
      Number(item.quantity)
    );
    total = theme.add(total, variantPriceCount);
  }
  return Number((total / 100).toFixed(2));
}

// 加购上报
theme.reportAddToCart = function (list) {
  // var userString = localStorage.getItem("user");
  // this.loginFlag = theme.inspectJson(userString)?.loginFlag;
  const loginFlag = theme.isLogin();
  if (loginFlag) {
    // const email = document.querySelector(".hmuser").dataset.email;
    const email = theme.getUserInfo()?.email ?? "";
    gtag("set", "user_data", { email });
  }
  const total = calculatePrice(list);
  var _paq = (window._paq = window._paq || []);
  _paq.push(["trackEcommerceCartUpdate", Number(total)]);

  const reportList = [];
  const items = [];
  for (let item of list) {
    reportList.push({
      content_id: item.variant_id,
      content_type: "product",
      content_name: item.product_title,
    });
    items.push({
      item_id: item.variant_id, //产品ID
      item_name: item.product_title, //产品标题
      price: item.original_price, //单价
      quantity: item.quantity, //数量
    });
  }
  ttq.track("AddToCart", {
    contents: reportList,
    value: Number(total), // number. Value of the order or items sold. Example: 100.
    currency: "USD", // string. The 4217 currency code. Example: "USD".
  });
  gtag("event", "add_to_cart", {
    currency: "USD", //当前币种,必须
    value: Number(total), //总金额
    items,
  });
  gtag("event", "conversion", {
    send_to: "AW-16627907402/JuFpCJzIoPgZEMr25vg9",
    value: Number(total), //产品价格
    currency: "USD",
  });
  gtag("event", "conversion", {
    send_to: "G-FR6KG7FRXN", //固定
    value: Number(total), //真实金额
    currency: "USD", //当前币种,必须
  });
};

// base64解码
const base64UrlDecode = function (base64Url) {
  // 将 Base64 URL 编码转换成标准的 Base64 编码
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");

  // 修复 Base64 字符串长度
  const paddedBase64 = base64.padEnd(
    base64.length + ((4 - (base64.length % 4)) % 4),
    "="
  );

  // 使用 atob 解码 Base64 字符串
  return atob(paddedBase64);
};

theme.decodeJWT = function (token) {
  const data = localStorage.getItem("userShopifyToken");
  if (data) {
    return data;
  }
  const payload = token.split(".")[1];
  const decodedPayload = base64UrlDecode(payload);

  // 将解码后的字符串转换为 JSON 对象
  const payloadObj = JSON.parse(decodedPayload);
  return payloadObj;
};
// 判断是否登录
theme.isLogin = function () {
  var token = theme.getCookies("token");
  const loginFlag = token ?? null;
  return loginFlag ? true : false;
};

// 获取用户信息
theme.getUserInfo = function () {
  var userString = theme.getCookies("userInfo");
  const userInfo = theme.inspectJson(userString);
  return userInfo;
};

// 登出
theme.logout = function () {
  theme.deleteCookie("token");
  theme.deleteCookie("userInfo");
};

// 错误上报
function reportError(errorInfo) {
  const uuid = generateUUIDv4();
  const url = "api/v1/bug/report";
  const params = {
    uuid: uuid,
    url: window.location.href,
    type: errorInfo.type,
    data: errorInfo.stack,
    env: navigator.userAgent,
  };
  fetchRequest(url, "POST", params);
}

// 给当前url添加参数
theme.addUrlParameters = function (params) {
  // 获取当前 URL
  const url = new URL(window.location.href);
  // 遍历参数对象并添加每个参数
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      url.searchParams.set(key, params[key]);
    }
  }

  // 使用 history.replaceState 更新 URL，不会导致页面跳转
  window.history.replaceState({}, "", url);
};

// 删除当前url中的某个参数
theme.removeUrlParameters = function (keys) {
  // 获取当前 URL
  const url = new URL(window.location.href);

  // 遍历参数数组并删除每个参数
  keys.forEach((key) => {
    url.searchParams.delete(key);
  });

  // 使用 history.replaceState 更新 URL，不会导致页面跳转
  window.history.replaceState({}, "", url);
};

theme.getAllUrlParameters = function () {
  const url = new URL(window.location.href);
  const params = {};
  url.searchParams.forEach((value, key) => {
    params[key] = value; // 将每个参数添加到对象中
  });
  return params;
};

theme.formatDateTime = (dateStr, options = {}) => {
  const {
    useLocalTime = true, // 是否转换为本地时间
    format = "YYYY-MM-DD HH:mm:ss", // 默认格式
  } = options;

  const date = new Date(dateStr);
  let targetDate = date;

  if (!useLocalTime) {
    // 保持UTC时间，不进行时区转换
    const offset = date.getTimezoneOffset() * 60000;
    targetDate = new Date(date.getTime() + offset);
  }

  const tokens = {
    YYYY: targetDate.getFullYear(),
    MM: String(targetDate.getMonth() + 1).padStart(2, "0"),
    DD: String(targetDate.getDate()).padStart(2, "0"),
    HH: String(targetDate.getHours()).padStart(2, "0"),
    mm: String(targetDate.getMinutes()).padStart(2, "0"),
    ss: String(targetDate.getSeconds()).padStart(2, "0"),
  };

  return format.replace(/YYYY|MM|DD|HH|mm|ss/g, (match) => tokens[match]);
};

window.addEventListener("DOMContentLoaded", function () {
  $(theme.wishList);
  $(theme.filtersss);
  $(theme.setSold);
  $(theme.getIsFreeShipping);

  $(".variant-qu .varirimg").click(function (event) {
    event.stopPropagation();
    const mediaGalleries = document.querySelector(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    const sliderItems = mediaGalleries.querySelectorAll('[id^="Slide-"]');
    let src = this.querySelector("img").src;
    src = src.replace("width=100", "width=416");
    const srcset = `${src} 493w,${src} 600w,${src} 713w,${src} 823w,${src} 990w,${src} 1100w,${src} 1200w`;
    sliderItems[0].querySelector("img").src = src;
    sliderItems[0].querySelector("img").srcset = srcset;
    const thumSlider = document.querySelector('[id^="GalleryThumbnails"]');
    const thumSliderItems = thumSlider.querySelectorAll('[id^="Slide-"]');
    thumSliderItems.forEach((slider) => {
      slider.querySelector(".thumbnail").removeAttribute("aria-current");
    });
  });

  $("#register-btn").click(() => {
    setCookie("registerTag", true, 5);
  });

  var _paq = (window._paq = window._paq || []);
  /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
  _paq.push(["trackPageView"]);
  _paq.push(["enableLinkTracking"]);
  (function () {
    var u = "//statx.gooddiy.com/";
    _paq.push(["setTrackerUrl", u + "matomo.php"]);
    _paq.push(["setSiteId", "1"]);
    var d = document,
      g = d.createElement("script"),
      s = d.getElementsByTagName("script")[0];
    g.async = true;
    g.src = u + "matomo.js";
    s.parentNode.insertBefore(g, s);
  })();
});

// 监听同步错误
window.onerror = function (message, source, lineno, colno, error) {
  if (!error || !error?.stack) return;
  // 构造错误信息对象
  const errorInfo = {
    message: message,
    source: source,
    lineno: lineno,
    colno: colno,
    stack: error?.stack,
    type: "js",
  };
  // 上报错误信息到指定接口
  reportError(errorInfo);
  // 返回 true 阻止默认的错误处理行为
  return true;
};

// 监听 Promise 未处理的拒绝错误
// window.addEventListener("unhandledrejection", function (event) {
//   const errorInfo = {
//     message: event.reason.message,
//     stack: event.reason.stack,
//   };
//   reportError(errorInfo);
// });
